/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Private_Chats_Disable_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Every member of this project will be able to see and open everyone's chats in it, with their attached files and AI-created documents — including those from w..." |
*
* @param {Project_Private_Chats_Disable_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_private_chats_disable_confirm_description = /** @type {((inputs?: Project_Private_Chats_Disable_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Private_Chats_Disable_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jedes Mitglied dieses Projekts kann dann die Chats aller Mitglieder darin sehen und öffnen, samt angehängten Dateien und KI-erstellten Dokumenten – auch aus der Zeit, in der Private Chats aktiv war.")
	return /** @type {LocalizedString} */ ("Every member of this project will be able to see and open everyone's chats in it, with their attached files and AI-created documents — including those from while private chats was on.")
});